<template>
  <div id="app" style="height: 100%">
    <transition>
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </transition>
  </div>
</template>
<script>
import { getTheme } from "@/utils/theme";
export default {
  name: "App",
  created() {
    localStorage.setItem("lang-home", this.$t("PUB.home"));
    localStorage.setItem("lang-person", this.$t("PUB.person"));
    if (!localStorage.getItem("language")) {
      localStorage.setItem("language", "en_US");
    }
    // 未登錄按鈕
    localStorage.setItem("lang-reLogin", this.$t("PUB.reLogin"));
    localStorage.setItem("lang-cancel", this.$t("PUB.cancel"));
    localStorage.setItem("lang-sysTips", this.$t("PUB.sysTips"));
    // 主题
    let theme = localStorage.getItem("lyods-theme") || "#1890ff";
    if (theme) {
      // 變更主題
      this.lyChangeTheme(theme, getTheme());
    }
  },
};
</script>

<style lang="scss">
@import "~@/assets/styles/lyods.scss";
@import "~@/assets/styles/awesome/font-awesome.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue